<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<thead {...$$restProps} on:click on:mouseover on:mouseenter on:mouseleave>
  <slot />
</thead>
